module.exports = __webpack_public_path__ + "img/app-store.579d72de.png";